<template>
    <div>
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
                <a :href="tab1href" role="tab" data-toggle="tab" @click="openShopStats()">
                    {{ t('Average rating for Shops') }}
                </a>
            </li>
            <li role="presentation">
                <a :href="tab2href" role="tab" data-toggle="tab" @click="openComments()">
                    {{ t('Comments') }}
                </a>
            </li>

        </ul>

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" :id="tab1ID">

                <br />

                <div class="row">
                    <div class="col-lg-5">

                        <table class="table table-condensnd">
                            <thead>
                                <tr>
                                    <th>{{ t('Shop') }}</th>
                                    <th>{{ t('Number of ratings') }}</th>
                                    <th>{{ t('Average rating') }}</th>
                                    <th>{{ t('Range') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in stats">
                                    <td>
                                        <a :href="item.link">{{ item.shop_name }}</a>
                                    </td>
                                    <td>{{ item.count }}</td>
                                    <td>{{ item.rate }}</td>
                                    <td>
                                        {{ item.down }} - {{ item.up }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="col-lg-7">

                        <default-chart :labels="chart.labels" :items="chart.items" :height="120"></default-chart>

                    </div>
                </div>

            </div>
            <div role="tabpanel" class="tab-pane" :id="tab2ID">

                <br />


                <div class="control-group">
                    <div class="controls form-inline">

                        <select v-model="selectedProduct" @change="dataTableRefresh=!dataTableRefresh" class="form-control">
                            <option value="0">{{ t('Select single product') }}</option>
                            <option v-for="product in products" v-bind:value="product.id">{{ product.shop_name }} - {{product.name}}</option>
                        </select>

                        <date-range-picker
                            :from-placeholder="t('From')"
                            :to-placeholder="t('To')"

                            :from-disabled="fromDisabled"
                            :to-disabled="toDisabled"

                            v-model="datepicker"

                            v-on:input="selectedDate"
                        >
                        </date-range-picker>

                        <div :id="'datatable-'+getTableId()+'-length-box'" class="pull-right"></div>
                        <div :id="'datatable-'+getTableId()+'-search-box'" class="pull-right"></div>

                    </div>
                </div>

                <br />

                <data-table
                        :dt-id="getTableId()"
                        :length-handle="'#datatable-'+getTableId()+'-length-box'"
                        :columns="columns"
                        :refresh="dataTableRefresh"
                        :my-ajax="dataTableAjax"
                        :search="{
                            handle: '#datatable-'+getTableId()+'-search-box',
                            placeholder: t('Search content')
                        }"
                        :sort="true"
                ></data-table>

            </div>
        </div>

    </div>
</template>
<script>
    import DataTable from "./DataTable.vue";
    import DefaultChart from "./DefaultChart";
    import DateRangePicker from './DateRangePicker.vue'

    const moment = require('moment');

    require('bootstrap');

    export default {
        components: {
            DataTable,
            DefaultChart,
            DateRangePicker
        },
        data() {
            return {
                shop: 0,
                shops: [],
                stats: [],
                products: [],
                selectedProduct: 0,
                comments: [],
                columns: [],
                dataTableRefresh: false,
                toggleFitlers: false,

                chart: {
                    labels: [],
                    items: [],
                },

                chartDateRangePickerPl: {
                    from: null,
                    to: null,
                },

                datepicker: {
                    from: null,
                    to: null,
                },
                fromDisabled: {
                    from: null,
                    to: null
                },
                toDisabled: {
                    from: null,
                    to: null
                }
            };
        },
        computed: {
            tab1ID() {
                return 'tab1_' + this.$data.id
            },
            tab2ID() {
                return 'tab2_' + this.$data.id
            },
            tab1href() {
                return '#tab1_' + this.$data.id
            },
            tab2href() {
                return '#tab2_' + this.$data.id
            },
        },
        mounted() {
            this.openShopStats();

            let dateNextDay= new Date();
//            dateNextDay.setDate(dateNextDay.getDate()+1);

            this.fromDisabled.from = dateNextDay;
            this.toDisabled.from = dateNextDay;

        },
        methods: {
            selectedDate: function() {
                this.dataTableRefresh = !this.dataTableRefresh;
            },
            customFormat: function(date) {
                return moment(date).format('DD.MM.YYYY');
            },
            getTableId: function() {
                return this.$data.id.toString();
            },
            dataTableAjax: function(data, callback)
            {
                const v = this;

                delete data.columns;
                data.from_date = v.datepicker.from ? v.customFormat(v.datepicker.from) : null;
                data.to_date = v.datepicker.to ? v.customFormat(v.datepicker.to) : null;
                data.selected_product_id = v.selectedProduct;

                v.$http.get('reviews/dt-comments/'+this.$data.id, {params: data},  {credentials: true}).then(response => {
                    callback(response.body)
                });
            },
            changeShop: function()
            {
                const v = this;

            },
            changeDaterange: function() {
                this.refreshChart();
            },
            openShopStats: function(){
                const v = this;

                this.chartDateRangePickerPl.to = new Date();

                v.$http.get('reviews/shop-stats/'+this.$data.id, {params: {}}).then((response) => {
                    v.stats = response.body;
                });

                this.refreshChart();

            },
            refreshChart: function() {
                const v = this;

                v.$http.get('reviews/chart/'+this.$data.id, {params: {
                    'to_date': v.customFormat(this.chartDateRangePickerPl.to)
                }}).then((response) => {
                    v.chart = response.body;
                });
            },
            loadShopComments: function() {
                const v = this;

            },
            openComments: function() {
                const v = this;

                v.$http.get('reviews/init-comments/'+this.$data.id, {params: {}}).then(response => {

                    v.columns = response.body.columns;
                    v.products = response.body.products

                    if (v.products.length)
                    {
                        v.dataTableRefresh = !v.dataTableRefresh;
                    }
                });

            }
        }
    }
</script>

<style scoped>
    .daterange-picker {
        display: inline-block;
        width: auto;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// ProductReviewDetail.vue?0baec3f8